import { ComuniInfo } from "../_models/comuniInfo"
import * as data from "../_store/data.module"
import { EnterpriseInfo } from "../_models/enterpriseInfo"
import { StudentInfo } from '@/_models/studentInfo';
import { UserInfo } from '@/_models/userInfo';
import axios from 'axios';
import { bus } from '@/main';


export const userUtils = {
  parseToken,
  checkEnterpriseInfo,
  checkStudentInfo,
  checkUserInfo,
  checkRespModule,
  parseDate
}
// const headUrl = "http://localhost:8181/RestApi/valtis/valtis"

const headUrl = "https://valtis.infosys.it/RestApi/valtis/valtis"

function parseToken(token: string): JSON {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

function checkEnterpriseInfo(enterpiseInfo: EnterpriseInfo): boolean {
  if (enterpiseInfo.cognomeRappresentanteAzienda !== null &&
    enterpiseInfo.cognomeRappresentanteAzienda !== "" &&
    enterpiseInfo.nomeRappresentanteAzienda !== null &&
    enterpiseInfo.nomeRappresentanteAzienda !== "" &&
    enterpiseInfo.dataNascitaRappresentante !== null &&
    enterpiseInfo.dataNascitaRappresentante !== "" &&
    enterpiseInfo.titolo !== "" &&
    enterpiseInfo.titolo !== null &&
    enterpiseInfo.statoNascitaRappresentante !== "" &&
    enterpiseInfo.statoNascitaRappresentante !== null &&
    enterpiseInfo.luogoNascitaRappresentante !== null &&
    enterpiseInfo.luogoNascitaRappresentante !== "" &&
    enterpiseInfo.idCapComuneAzienda !== null &&
    enterpiseInfo.indirizzoAzienda !== null &&
    enterpiseInfo.indirizzoAzienda !== "" &&
    enterpiseInfo.telefono1Azienda !== null &&
    enterpiseInfo.telefono1Azienda !== "" &&
    enterpiseInfo.emailAzienda !== null &&
    enterpiseInfo.emailAzienda !== "" &&
    enterpiseInfo.attivitàAzienda !== null &&
    enterpiseInfo.attivitàAzienda !== "" &&
    enterpiseInfo.dipendentiAzienda !== null &&
    enterpiseInfo.dipendentiAzienda !== "" &&
    enterpiseInfo.pIva !== null &&
    enterpiseInfo.pIva !== "" &&
    enterpiseInfo.idAteco !== null &&
    // enterpiseInfo.idIstat !== null &&
    enterpiseInfo.cap !== null &&
    enterpiseInfo.cap !== "" &&
    enterpiseInfo.idNazioneAzienda !== null &&
    enterpiseInfo.idNazioneAzienda !== "" &&
    enterpiseInfo.codRappresentate !== null &&
    enterpiseInfo.codRappresentate !== "") {
    if (enterpiseInfo.idCapComuneAzienda === 0) {
      if (
        enterpiseInfo.comuneAzienda !== null &&
        enterpiseInfo.comuneAzienda !== "") {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  } else {
    return false
  }
}

// enterpiseInfo.comuneAzienda !== null &&
//     enterpiseInfo.comuneAzienda !== "" &&

function checkStudentInfo(studentInfo: StudentInfo): boolean {
  if (studentInfo.nomeUtente !== null &&
    studentInfo.nomeUtente !== "" &&
    studentInfo.cognomeUtente !== null &&
    studentInfo.cognomeUtente !== "" &&
    studentInfo.indirizzoUtente !== null &&
    studentInfo.indirizzoUtente !== "" &&
    studentInfo.telefono1Utente !== null &&
    studentInfo.telefono1Utente !== "" &&
    studentInfo.dataNascita !== null &&
    studentInfo.dataNascita !== "" &&
    studentInfo.luogoNascita !== null &&
    studentInfo.luogoNascita !== "" &&
    studentInfo.emailUtente !== null &&
    studentInfo.emailUtente !== "" &&
    studentInfo.idCap !== null &&
    studentInfo.cap !== null &&
    studentInfo.cap !== "" &&
    studentInfo.idNazioneNascita !== null) {
    return true
  } else {
    return false
  }
}

function checkUserInfo(userInfo: UserInfo): boolean {
  if (userInfo.nomeUtente !== null &&
    userInfo.nomeUtente !== "" &&
    userInfo.cognomeUtente !== null &&
    userInfo.cognomeUtente !== "" &&
    userInfo.indirizzoUtente !== null &&
    userInfo.indirizzoUtente !== "" &&
    userInfo.telefono1Utente !== null &&
    userInfo.telefono1Utente !== "" &&
    userInfo.dataNascita !== null &&
    userInfo.dataNascita !== "" &&
    userInfo.luogoNascita !== null &&
    userInfo.luogoNascita !== "" &&
    userInfo.emailUtente !== null &&
    userInfo.emailUtente !== "" &&
    userInfo.idCap !== null &&
    userInfo.cap !== null &&
    userInfo.cap !== "") {
    return true
  } else {
    return false
  }
}

function checkRespModule(idAzienda: number, idIstituto: number) {
  var token: string | null = localStorage.getItem('userToken')
  return axios.get(headUrl + "/GetRespDoc", {
    params: {
      idAzienda: idAzienda,
      idIstituto: idIstituto
    },
    headers: {
      Authorization: 'Bearer ' + token
    }
  }).then(result => {
    return result.data
  })
    .catch(error => {
      bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
      throw error
    })
}

function parseDate(date: string): string {
  var dateArray: string[] = [];
  var parsedDate: string = '';
  if (date !== null){
    dateArray = date.split('-');
    parsedDate = dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0];
  }
  return parsedDate;
}